<div class="mysusersettingsscrolldiv">
	<!-- #region App-Level SubGroups -->
	<form #userSettingsForm="ngForm" name="userSettingsForm">
		@if (subGroupList && !isAppWide) {
		<div class="row">
			<div class="col-form-label settings-label">SubGroup:</div>
			<div class="col-sm-4">
				<select #subgroups id="subgroups" name="subgroups" [(ngModel)]="selectedSubGroupID"
					(change)="getSubGroupCommunities(selectedSubGroupID)" class="form-control">
					<option value="0"></option>
					@for (subGroup of subGroupList; track subGroup) {
					<option [ngValue]="subGroup.subGroupID">
						{{subGroup.subGroupName}}
						-
						{{subGroup.divisionName}}
					</option>
					}
				</select>
			</div>
			<div class="d-none d-md-block d-lg-none col-md-5 ">
				<input type="text" class="form-control" [value]="user.subGroup ? user.subGroup.subGroupName : ''"
					readonly />
			</div>
			<div class="mt-3 col-lg-10">
				@if (subGroupCommunities?.length > 0) {
				<p-table [value]="subGroupCommunities" class="p-datatable-striped p-datatable-gridlines">
					<ng-template #header>
						<tr>
							<th>Community Name</th>
							<th>Status</th>
						</tr>
					</ng-template>
					<ng-template #body let-subGroupCommunity>
						<tr>
							<td>{{subGroupCommunity.orgName}}</td>
							<td>{{subGroupCommunity.constructionStatusId | orgStatus}}</td>
						</tr>
					</ng-template>
				</p-table>
				}
			</div>
		</div>
		}
	</form>
</div>

<pcp-commandbar [isPositionFixed]="true">
	<command-button button-right text="Cancel" [iconClasses]="['fas fa-undo']"
		(commandClick)="cancelUserSettingChanges()" [enabled]="userSettingsForm.dirty" />
	<command-button button-right text="Save" [iconClasses]="['fas fa-save']" (commandClick)="saveUpdatedSubgroup()"
		[enabled]="userSettingsForm.dirty" />
</pcp-commandbar>
<!-- #endregion -->